<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">User Functions</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create Role</p>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">
            <!-- <button type="button" class="close-button" @click="handleClose">
                        &times;
                    </button> -->

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Create Role</h1>
              </div>

              <!-- <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p> -->
              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                      <label for="roleName" class="form-label">Role Name</label>
                    </div>
                    <div class="col-md-10 input-right">
                      <input type="text" class="form-control" id="roleName" v-model="roleName" placeholder="" required />
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                      <label for="first_name">Description</label>
                    </div>
                    <div class="col-md-10 input-right">
                      <textarea class="form-control" id="description" v-model="description" placeholder="" rows="3"
                        required></textarea>
                    </div>
                  </div>

                  <div class="d-flex justify-content-center">
                    <button class="submit-btn" type="submit" :disabled="isLoading">
                      <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {{ isLoading ? "Submitting..." : "Submit" }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </DashboardLayout>
</template>

<script setup>
import axios from "axios";
import Cookies from "js-cookie";
import { ref, onMounted } from "vue";
import DashboardLayout from "../layout/DashboardLayout.vue";
import Swal from "sweetalert2";
import { useUserStore } from "@/stores/user";

const roleName = ref("");
const description = ref("");

const isLoading = ref(false);
const errorMessage = ref("");
const userStore = useUserStore();

const root_api_url = process.env.VUE_APP_API_ROOT_URL;

onMounted(() => {
  document.title = "Create Role"
})

async function handleSubmit() {
  const token = Cookies.get("auth_token");

  if (!token) {
    alert("You must be logged in to perform this action.");
    return;
  }

  if (!userStore.profile) {
    await userStore.fetchProfile();
  }

  if ((!userStore.bizClientId || userStore.bizClientId === 0) && userStore.rid) {
    await userStore.fetchRole(userStore.rid);
  }

  const roleData = {
    roleName: roleName.value.trim(),
    description: description.value.trim(),
    bizClientId: Number(userStore.bizClientId) || 0,
  };

  isLoading.value = true;
  errorMessage.value = "";
  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`;
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`;

  try {
    const response = await axios.post(`${root_api_url}/auth/role`, roleData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200 || response.status === 201) {
      Swal.fire({
        // title: 'Success!',
        html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Role created successfully!</p> `,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
      roleName.value = "";
      description.value = "";
    } else {
      errorMessage.value = "Failed to create role.";
      Swal.fire({
        html: `${iconHtmlError}
                  <h1 style="font-weight:600;">Error</h1>
                  <p>Failed to create role.</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } catch (err) {
    if (err?.response?.status === 400) {
      errorMessage.value = "Invalid data provided.";
    } else if (err?.response?.status === 403) {
      errorMessage.value = "Unauthorized. Please log in again.";
    } else if (err?.response?.status === 503) {
      errorMessage.value = "Service unavailable. Please try again later.";
    } else {
      errorMessage.value = "Unexpected error occurred, kindly contact administrator.";
    }
    Swal.fire({
      html: `${iconHtmlError}
              <h1 style="font-weight:600;">Error</h1>
              <p>${errorMessage.value}</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
  } finally {
    isLoading.value = false;
  }
}
</script>
